import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=3e2ff3f8&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e2ff3f8')) {
      api.createRecord('3e2ff3f8', component.options)
    } else {
      api.reload('3e2ff3f8', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=3e2ff3f8&", function () {
      api.rerender('3e2ff3f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/login2/views/ForgotPassword.vue"
export default component.exports